export default "__VITE_ASSET__CvK7Uvq___"